const houstonPallete = {
  primary: {
    light: '#00C853',
    main: '#00A526',
    dark: '#00642e',
    contrastText: '#fff',
  },
  secondary: {
    light: '#9EB5D9',
    main: '#0D47A1',
    dark: '#072D83',
    contrastText: '#fff'
  },
  info: {
    light: '#CDEBFA',
    main: '#0277B0',
    dark: '#039BE5',
    contrastText: '#fff'
  },
  warning: {
    main: '#FFCA28',
    dark: '#E5AD00',
    light: '#FFF4D4',
    contrastText: '#37474F'
  },
  error: {
    light: '#FDD9D7',
    main: '#F44336',
    dark: '#B8160A',
    contrastText: '#fff'
  },
  success: {
    light: '#D2EBD3',
    main: '#4caf50',
    dark: '#388e3c',
    contrastText: '#000'
  },
  common: {
    black: '#000',
    white: '#fff'
  },
  grey: {
    50: '#fafafa',
    100: '#F9FAFB',
    200: '#ECEFF1',
    300: '#B0BEC5',
    400: '#78909C',
    500: '#546E7A',
    600: '#37474F',
    700: '#373737',
    800: '#272727',
    900: '#1E1E1E',
    A100: '#1E1E1E',
    A200: '#1E1E1E',
    A400: '#1E1E1E',
    A700: '#1E1E1E',
  }
}

export default houstonPallete